import React from 'react';
import styles from './shipping.module.scss';
export default function Shipping() {
  return (
    <div className={styles.wrapper}>Shipping</div>
  );
}
